import * as React from 'react';
export const IcWifiStrength3 = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      opacity={0.2}
      d='M21.34 8.59a13.94 13.94 0 00-18.68 0A1.002 1.002 0 004 10.08a11.93 11.93 0 0116 0 1 1 0 00.67.25 1 1 0 00.67-1.74zM12 17a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-3.59-2.79a1 1 0 101.2 1.6 4 4 0 014.78 0 1 1 0 001.2-1.6 6 6 0 00-7.18 0zM12 9a10 10 0 00-6.49 2.4 1 1 0 001.3 1.52 8 8 0 0110.38 0 1 1 0 101.3-1.52A10 10 0 0012 9z'
      fill='currentColor'
    />
    <path
      d='M12 17a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-3.59-2.79a1 1 0 101.2 1.6 4 4 0 014.78 0 1 1 0 001.2-1.6 6 6 0 00-7.18 0zm10.08-2.81a10 10 0 00-13 0 1 1 0 001.3 1.52 8 8 0 0110.38 0 1 1 0 001.3-1.52h.02z'
      fill='currentColor'
    />
  </svg>
);
